
export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Full-bleed background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/44752845a04e2f8441fffa448c4ef740.jpg"
          alt="AI Desk Pilots background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B1C2D]/80 via-[#0B1C2D]/70 to-[#0B1C2D]/90" />
      </div>

      {/* Top Nav */}
      <nav className="absolute top-0 left-0 right-0 z-20 py-6 px-6 lg:px-12">
        <div className="container mx-auto flex items-center justify-between">
          <img
            src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/a87c6accb67913e772b0b6a3d4e967b2.png"
            alt="AI Desk Pilots"
            className="h-10 w-auto"
          />
          <button className="px-6 py-2.5 bg-white/10 backdrop-blur-md text-white text-sm font-semibold rounded-full hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer border border-white/20">
            Get Started
          </button>
        </div>
      </nav>

      {/* Centered Content — Apple style */}
      <div className="container mx-auto px-6 lg:px-12 relative z-10 text-center pt-20">
        <div className="max-w-4xl mx-auto space-y-8">
          <p className="text-sm font-semibold tracking-[0.25em] uppercase text-[#2563EB]">
            AI Desk Pilots
          </p>

          <h1 className="text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-white leading-[1.05] tracking-tight">
            Momentum Built Into
            <br />
            Your Front Desk.
          </h1>

          <p className="text-lg lg:text-xl text-gray-300/90 leading-relaxed max-w-2xl mx-auto font-light">
            Intelligent intake and automation systems that capture, qualify, and convert every inbound opportunity — automatically.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-6">
            <a href="#audit" className="px-8 py-4 bg-[#2563EB] text-white font-semibold text-base rounded-full hover:bg-[#1d4ed8] transition-all duration-300 shadow-lg shadow-[#2563EB]/25 hover:shadow-xl hover:shadow-[#2563EB]/30 whitespace-nowrap cursor-pointer">
              Schedule a Systems Audit
            </a>
            <a href="#framework" className="px-8 py-4 bg-white/10 backdrop-blur-md border border-white/20 text-white font-semibold text-base rounded-full hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer">
              See How It Works
            </a>
          </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent z-10" />
    </section>
  );
}
